// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class HorseContacts extends Model {
    static table = 'horse_contacts';

    static associations = {
        horses: { type: 'belongs_to', key: 'horse_id' },
        contacts: { type: 'belongs_to', key: 'contact_id' },
    };

    @field('horse_id') horseId;
    @field('contact_id') contactId;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;
}

export type HorseContactSimple = {
    horseId: string;
    contactId: string;
    userId: string;
    organisationId: string;
    createdAt: string;
    updatedAt: string;
};
